<template>
  <div>
    <span>

      <button v-on:click="detayaGit()" style="border: none; background: none; margin-right: 5px">
        <Icon icon="akar-icons:search" color="#7367f0" width="15" height="15" />
      </button>
    </span>
  </div>
</template>
<script>
import router from "../../../../router";
import { Icon } from "@iconify/vue2";
export default {
  components: { Icon },
  methods: {

    detayaGit() {
      localStorage.setItem("MAL_KABUL_DETAY", this.params.data.RECEIPTID);
      this.$store.commit("account/MAL_KABUL_DETAY", this.params.data);
      const route = this.$router.resolve({
        name: 'MalKabulDetay',
        params: { items_id: this.params.data.RECEIPTID },
      });
      window.open(route.href, '_blank');
    },
  },
};
</script>